// extracted by mini-css-extract-plugin
export default {"description":"style_description__qmqZR","fade-in":"style_fade-in__FuNyC","top":"style_top__0K3NL","image":"style_image__VtB0Y"};